import { format } from 'date-fns';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, NothingHere } from 'Mri.Web.Common';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { BiStore } from '../BI/BiStore';

export interface IHotTicketsListProps {
    readonly loading: boolean;
}

@autoinject
@observer
export class HotTicketsList extends React.Component<IHotTicketsListProps> {
    public render() {
        return (
            <div className="h-100 d-flex flex-column">
                <p className="w-100 text-center mb-1">Support Tickets</p>

                <div className="card flex-grow-1">
                    <div className="reported-tickets">
                        {this.biStore.ticketReportModel?.topTickets.map(t => (
                            <table className="table table-hover w-100 mb-0" key={t.ticketId}>
                                <tbody>
                                    <tr className="cursor-pointer dark-theme-top-border tickets-row rounded">
                                        <td scope="row" className="px-1 align-middle p-relative">
                                            <LinkContainer className="m-0" to={`/displays/${t.displaySerialNumber}`}>
                                                <div className="container-fluid  ">
                                                    <div className="row">
                                                        <div className="col-9">
                                                            <div className="flex-items-center h-100">
                                                                <div className="w-100">
                                                                    <small>{t.displaySerialNumber}</small>
                                                                    <div>{t.subject}</div>

                                                                    <small>
                                                                        Updated:{' '}
                                                                        {format(t.dateUpdated, 'MMMM d, yyyy, h:mm a')}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-3 text-end">
                                                            <div className="flex-items-center h-100">
                                                                <div className="w-100">
                                                                    <strong className={this.statusClassName(t.status)}>
                                                                        <small>{t.status.toUpperCase()}</small>
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </LinkContainer>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}

                        <NothingHere
                            empty={!this.biStore.ticketReportModel?.topTickets.length}
                            label="No Active Tickets"
                            loading={this.props.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }

    @bind
    private statusClassName(status: string) {
        switch (status) {
            case 'pending':
                return 'badge bg-info';
            case 'open':
                return 'badge bg-danger';
            case 'hold':
                return 'badge bg-warning';
        }
    }

    @inject
    private biStore!: BiStore;
}
